import { Col, Row } from 'react-bootstrap';
import { Button } from "primereact/button";
import React, { useState } from "react";
import { InputTextarea } from "primereact/inputtextarea";
import { Avatar } from 'primereact/avatar';
import { FaFilePdf, FaFileWord, FaFileExcel, FaFileAlt } from 'react-icons/fa';
import { getSocket } from "../context/socket";
import { useAuth } from '../context/AuthContext';

const FileSection = ({ section, cardId }) => {

    const getFileIcon = (type) => {
        switch (type) {
            case 'pdf':
                return <FaFilePdf className="text-danger me-2" />;
            case 'doc':
            case 'docx':
                return <FaFileWord className="text-primary me-2" />;
            case 'xls':
            case 'xlsx':
            case 'csv':
                return <FaFileExcel className="text-success me-2" />;
            case 'ppt':
            case 'pptx':
                return <i className="pi pi-file" style={{ color: 'orange', marginRight: '0.5rem' }} />;
            case 'txt':
            case 'md':
                return <FaFileAlt className="text-muted me-2" />;
            default:
                return <i className="pi pi-file" style={{ marginRight: '0.5rem' }} />;
        }
    };

    const { userId } = useAuth();
    const [showCommentId, setShowCommentId] = useState(null);
    const [commentText, setCommentText] = useState('');
    const [replacingFileId, setReplacingFileId] = useState(null);

    const socket = getSocket();

    const handleAddComment = (file) => {
        socket.emit("add_card_comment", {
            card_id: cardId,
            card_section_id: section.section_id,
            reference_id: file.file_id,
            comment_type: "file",
            comment_text: commentText,
            user_id: userId
        });

        setCommentText('');
    };

    const handleResolveComment = (comment_id) => {
        socket.emit("resolve_card_comment", {
            card_id: cardId,
            comment_id,
            user_id: userId
        });

    };

    const handleDeleteFile = (file) => {
        socket.emit("delete-card-file", {
            file_id: file.file_id,
            card_id: cardId,
            user_id: userId
        });
    };

    const handleFileReplace = (e, file) => {
        const selectedFile = e.target.files[0];
        if (!selectedFile) return;
    
        const reader = new FileReader();
    
        reader.onload = () => {
            const base64Data = reader.result.split(',')[1]; // remove data:*/*;base64, part
    
            socket.emit("replace-card-file", {
                file_id: file.file_id,
                card_id: cardId,
                user_id: userId,
                newFile: {
                    file: base64Data,
                    filename: selectedFile.name
                }
            });
        };
    
        reader.readAsDataURL(selectedFile); // triggers `onload`
    };
    
    

    return (
        <>
            <div className="d-flex justify-content-between align-items-start">
                <h6><i className="pi pi-file me-2 text-info"></i> <b>{section.section_name}</b></h6>
            </div>
            <div className='taskdataLink'>
                {section.files.map(file => (
                    <div className={`d-flex align-items-center gap-3 justify-content-between catdHover py-2 ${showCommentId === file.file_id ? 'example-1' : ''}`} key={file.file_id} onClick={() => setShowCommentId(file.file_id)}>

                        <a href={file.cdn_url} target="_blank" rel="noopener noreferrer" className='d-flex w-100 justify-content-between align-items-start'>
                            <span style={{ fontSize: '20px' }}>{getFileIcon(file.file_type)}</span>
                            <p className="mb-0 justify-content-between w-100">
                                <small className='text-info'>{file.filename || 'Uploaded File'}</small>
                                <small className="text-secondary d-block" style={{ fontSize: '12px' }}> Last Upadted : <span>{new Date(file.updatedAt).toLocaleDateString('en-GB', { day: '2-digit', month: 'short', year: 'numeric' })}</span>
                                </small>
                            </p>
                        </a>

                        <div style={{ width: '100px' }} className="d-flex justify-content-end ">
                            <Button
                                tooltip="Replace File"
                                icon="pi pi-pencil"
                                text
                                severity="secondary"
                                className="border-0 p-0 me-2"
                                onClick={(e) => {
                                    e.stopPropagation();  // ⛔ prevent parent click
                                    document.getElementById(`replace-file-${file.file_id}`).click(); // trigger input manually
                                }}
                            >
                                <input
                                    id={`replace-file-${file.file_id}`}
                                    type="file"
                                    accept="*"
                                    hidden
                                    onChange={(e) => handleFileReplace(e, file)}
                                    onClick={(e) => e.stopPropagation()} // prevent parent click again on input click
                                />
                            </Button>

                            <div className="position-relative">
                                <Button
                                    icon="pi pi-comments"
                                    tooltip="Comment"
                                    className="border-0 p-1"
                                    severity='secondary'
                                    text
                                    onClick={(e) => {
                                        e.stopPropagation();  // ⛔ prevent parent click
                                        setShowCommentId(prev => prev === file.file_id ? null : file.file_id);
                                    }}>
                                    {file.comments?.length > 0 && (
                                        <span
                                            style={{
                                                position: 'absolute',
                                                top: '-4px',
                                                right: '1px',
                                                background: 'rgb(255 255 255)',
                                                border: '1px solid rgb(228, 45, 119)',
                                                color: 'rgb(228, 45, 119)',
                                                borderRadius: '50%',
                                                width: '15px',
                                                height: '15px',
                                                display: 'flex',
                                                alignItems: 'center',
                                                justifyContent: 'center',
                                                fontSize: '9px',
                                                fontWeight: '600'
                                            }}
                                        >
                                            {file.comments.length}
                                        </span>
                                    )}
                                </Button>
                            </div>

                            <Button
                                tooltip="Delete"
                                icon="pi pi-times"
                                text
                                severity="danger"
                                className="border-0 p-0"
                                onClick={(e) => {
                                    e.stopPropagation();
                                    handleDeleteFile(file);
                                }}
                            />
                        </div>
                    </div>
                ))}
            </div>
            <div className="p-0">
                {/* Comment popup */}
                {showCommentId && (
                    <div className="img-comment mt-3 ">
                        <Button
                            icon="pi pi-times"
                            className="p-button-text p-button-sm cmtclose no-drag p-0"
                            style={{
                                position: 'absolute',
                                top: '-9px',
                                right: '-5px',
                                padding: '0px',
                                background: '#ff0000',
                                width: '20px',
                                height: '20px', 
                                borderRadius: '50% !important',
                                left: 'auto',
                                color: '#fff',
                            }}
                            onClick={() => setShowCommentId(null)}
                        />

                        {section.files.find(file => file.file_id === showCommentId)?.comments?.map(comment => (
                            <div
                                key={comment.comment_id}
                                className='d-flex gap-2 comDiv align-items-start mb-2'
                            >
                                <Avatar
                                    image={comment.creator?.profileImage?.image_url}
                                    label={comment.creator?.first_name?.[0]}
                                    shape="circle"
                                />
                                <div className="w-100">
                                    <p className="mb-1">
                                        <strong>{comment.creator.first_name} {comment.creator.last_name}</strong>
                                    </p>
                                    <p className="mb-1">{comment.comment_text}</p>
                                    <small className="text-muted d-block mb-2">
                                        {new Date(comment.createdAt).toLocaleString('en-GB', {
                                            day: '2-digit', month: 'short', year: 'numeric', hour: '2-digit',
                                            minute: '2-digit',
                                            hour12: true
                                        })}
                                    </small>

                                    <div className="d-flex justify-content-between">
                                        <Button
                                            title="Resolve"
                                            icon="pi pi-check-circle"
                                            severity="secondary"
                                            text
                                            className="p-0"
                                            onClick={() => handleResolveComment(comment.comment_id)}
                                            style={{
                                                position: 'absolute',
                                                background: 'transparent',
                                                top: '-5px',
                                                right: '-5px',
                                            }}
                                        />
                                    </div>
                                </div>
                            </div>


                        ))}

                        < div className="mt-3" >
                            <InputTextarea
                                value={commentText}
                                onChange={(e) => setCommentText(e.target.value)}
                                className="px-2 py-1 w-100"
                                placeholder="Add a comment..."
                                rows={2}
                            />
                            <div className="text-end mt-1">
                                <Button
                                    label="Send"
                                    severity="help+"
                                    className="py-1 border-0"
                                    onClick={() =>
                                        handleAddComment(

                                            section.files.find(file => file.file_id === showCommentId)
                                        )
                                    }
                                    disabled={!commentText.trim()}
                                />
                            </div>
                        </div>
                    </div>
                )}
            </div >
        </>





    );
};

export default FileSection;
